import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface ProgressBarProps {
    value: number
    label: string
    color?: string
    className?: string
}

export const ProgressBar: FC<ProgressBarProps> = ({ value, label, color = 'var(--brand)', className }): ReactNode => {
    const clamped = Math.max(0, Math.min(100, value))

    return (
        <div
            role='progressbar'
            aria-label={label}
            aria-valuemin={0}
            aria-valuemax={100}
            aria-valuenow={Math.round(clamped)}
            className={cn('h-2 overflow-hidden rounded-full bg-muted', className)}
        >
            <div className='h-full rounded-full transition-[width] duration-500' style={{ width: `${clamped}%`, background: color }} />
        </div>
    )
}
